import { clearServiceExceptionListState, getServiceExceptionListFailState, getServiceExceptionListStartedState, getServiceExceptionListSuccessState } from '../../../reducer/services/ServiceExceptionReducer';
import { ClearServiceExceptionList, GetServiceExceptionListFailure, GetServiceExceptionListFailurePayload, GetServiceExceptionListStarted, GetServiceExceptionListSuccess, GetServiceExceptionListSuccessPayload } from '../../types/services/GetServiceExceptionListTypes';

/**
 * Fetch service Exception List started saga action
 * @returns service Exception List started action
 */
export const getServiceExceptionListStarted = (): GetServiceExceptionListStarted => ({
  type: getServiceExceptionListStartedState.type
});

/**
 * Fetch service Exception List success saga action
 * @param payload :Service Exception List data
 * @returns success action
 */
export const getServiceExceptionListSuccess = (
  payload: GetServiceExceptionListSuccessPayload
): GetServiceExceptionListSuccess => ({
  type: getServiceExceptionListSuccessState.type,
  payload
});

/**
 * Fetch Service Exception List Failed saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const getServiceExceptionListFailure = (
  payload: GetServiceExceptionListFailurePayload
): GetServiceExceptionListFailure => ({
  type: getServiceExceptionListFailState.type,
  payload
});

/**
 * Clear Service Exception List saga action
 */
export const clearServiceExceptionList = (): ClearServiceExceptionList => ({
  type: clearServiceExceptionListState.type
});
